import { Typography, Box, CircularProgress } from '@mui/material';
import queryString from 'query-string';
import { Fragment, useEffect, useState } from 'react';

import { useGetTextForViewer } from '../api/useTextViewer';

export function TextViewer() {
    const queryParams = queryString.parse(window.location.search);

    const { data, isLoading } = useGetTextForViewer(queryParams.fileToken);

    useEffect(() => {
        if (queryParams.source === 'file-indexing') {
            if (!queryParams.fileToken && typeof queryParams.fileToken !== 'string') {
                console.error('params invalido');
            }
        }
        else {
            console.error('source inválido');
        }
    }, []);

    return (
        <Fragment>
            {isLoading ?
                (<Box style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </Box>) :
                (<Box style={{ width: '100vw', height: '100vh', display: 'flex', overflowX: 'auto', overflowY: 'auto' }}>
                    <Typography style={{ whiteSpace: 'pre' }}>
                        {data}
                    </Typography>
                </Box>)
            }
        </Fragment>
    );
}